import { Component, EventEmitter, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-same-airport',
  imports: [TranslateModule],
  templateUrl: './same-airport.component.html',
  styleUrl: './same-airport.component.css',
})
export class SameAirportComponent {
  @Output() close = new EventEmitter<void>();

  ngOnInit() {
    document.body.style.overflow = 'hidden';
  }

  closePopup() {
    document.body.style.overflow = '';

    this.close.emit();
  }
}
